import { Component } from '@angular/core';

@Component({
	selector: 'sm-p404',
	template: require('./p404.component.html')
})
export class SmP404Component { }


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/p404.component.ts